import cleanseNumber from '../../modules/cleanseNumber';

export function calculateDistance(lat1, lng1, lat2, lng2) {
        lat1 =  cleanseNumber(lat1);
        lat2 =  cleanseNumber(lat2);
        lng1 =  cleanseNumber(lng1);
        lng2 =  cleanseNumber(lng2);

        if (lat1 == 0 ||
            lat2 == 0 ||
            lat1 - lat2 == 0 ||
            lng1 - lng2 == 0) {
            return 0;
        }

        const dLat = Math.PI / 180 * (lat1 - lat2);
        const dLon = Math.PI / 180 * (lng1 - lng2);
        const dlat1 = Math.PI / 180 * (lat2);
        const dlat2 = Math.PI / 180 * (lat1);

        if (dLat == 0 ||
            dLon == 0) {
            return 0;
        }

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(dlat1) * Math.cos(dlat2);
        return (6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) * 0.6214;
};

export default { calculateDistance };